import {useEffect, useRef} from 'react';
import type {MessagePartComponentProps} from '../MessagePartComponentContext';
import {useWidget} from '../../Widget';

export function CheckoutStudioBuilderFormStatePartComponent({
  part,
}: MessagePartComponentProps) {
  const formStateJson = (part.content as {form_state?: string}).form_state;
  const widget = useWidget();
  const hasApplied = useRef(false);

  useEffect(() => {
    if (hasApplied.current || !formStateJson) {
      return;
    }

    const formState = JSON.parse(formStateJson) as Record<string, unknown>;
    widget.requestAction({
      name: 'update-config',
      data: formState,
    });
    hasApplied.current = true;
  }, [formStateJson, widget]);

  return null;
}
